import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const buildItems = () => {
    if (totalPages <= 10) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = new Set([1, 2, 3, totalPages - 2, totalPages - 1, totalPages]);
    const currentStart = Math.max(1, currentPage - 1);
    const currentEnd = Math.min(totalPages, currentPage + 1);

    for (let p = currentStart; p <= currentEnd; p += 1) {
      pages.add(p);
    }

    const sorted = Array.from(pages)
      .filter((p) => p >= 1 && p <= totalPages)
      .sort((a, b) => a - b);

    const items = [];
    for (let i = 0; i < sorted.length; i += 1) {
      const page = sorted[i];
      const prev = sorted[i - 1];
      if (i > 0 && page - prev > 1) {
        items.push("ellipsis-" + page);
      }
      items.push(page);
    }

    return items;
  };

  const items = buildItems();

  return (
    <nav className="pagination" aria-label="Пагинация заявок">
      <button
        type="button"
        className="pagination-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="fa-solid fa-chevron-left" aria-hidden="true"></i>
      </button>

      {items.map((item) => {
        if (typeof item === "string") {
          return (
            <span key={item} className="pagination-ellipsis" aria-hidden="true">
              ...
            </span>
          );
        }

        return (
          <button
            key={item}
            type="button"
            className={`pagination-btn ${item === currentPage ? "active" : ""}`}
            onClick={() => onPageChange(item)}
            aria-current={item === currentPage ? "page" : undefined}
          >
            {item}
          </button>
        );
      })}

      <button
        type="button"
        className="pagination-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    </nav>
  );
};

export default Pagination;
